import { render, staticRenderFns } from "./AdminDataTable.vue?vue&type=template&id=64c70302&"
import script from "./AdminDataTable.vue?vue&type=script&lang=js&"
export * from "./AdminDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports